import setStatic from "./setStatic";
export var setDisplayName = function setDisplayName(name) {
  return setStatic("displayName", name);
};
export default setDisplayName;